import * as React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import { slugToCamelCase } from 'drf-react-by-schema';

import PAGES from '../pageTree';

import * as Page from '../pages';
import AuthRoute from '../components/AuthRoute';
import { getPageComponent, getPageListFormAndDetail } from 'src/utils/utils';
// import NewUsuariaForm from '../components/NewUsuariaForm';

export default function MainNavigation() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AuthRoute />}>
          <Route path="/" element={<Page.Home />} />
          {Object.entries(PAGES).map(([key, { type, skipRouter }]) => {
            if (skipRouter) {
              return null;
            }
            const Component = getPageComponent(Page, key);
            const [ComponentList, ComponentForm, ComponentDetail] = getPageListFormAndDetail(
              Page,
              key
            );
            switch (type) {
              case 'singlePage':
                return <Route key={key} path={key} element={<Component />} />;
              case 'hasListFormDetail':
                return (
                  <React.Fragment key={key}>
                    <Route path={key} element={<ComponentList />} />
                    <Route path={`${key}/create`} element={<ComponentForm />} />
                    <Route path={`${key}/edit/:objId`} element={<ComponentForm />} />
                    <Route path={`${key}/view/:objId`} element={<ComponentDetail />} />
                  </React.Fragment>
                );
              case 'hasFormDetail':
                return (
                  <React.Fragment key={key}>
                    <Route path={key} element={<ComponentDetail />} />
                    <Route path={`${key}/create`} element={<ComponentForm />} />
                    <Route path={`${key}/edit/:objId`} element={<ComponentForm />} />
                    <Route path={`${key}/view/:objId`} element={<ComponentDetail />} />
                  </React.Fragment>
                );
              case 'createOnly':
                return (
                  <React.Fragment key={key}>
                    <Route path={key} element={<ComponentForm />} />;
                    <Route path={`${key}/create`} element={<ComponentForm />} />;
                  </React.Fragment>
                );

              case 'editOnly':
                return (
                  <React.Fragment key={key}>
                    <Route path={key} element={<ComponentForm />} />;
                    <Route path={`${key}/edit/:objId`} element={<ComponentForm />} />;
                  </React.Fragment>
                );
            }
          })}
          <Route
            path="*"
            element={
              <main>
                <p>Página não encontrada!</p>
              </main>
            }
          />
        </Route>
        <Route path="/login" element={<Page.Login />} />
        <Route path="/password-reset" element={<Page.PasswordReset />} />
      </Routes>
    </BrowserRouter>
  );
}
